var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hg",style:(_vm.getColumns())},_vm._l((_vm.waves),function(wave,index){return _c('div',{key:index,staticClass:"txt"},[_c('div',[_vm._v(_vm._s(wave.name)+" "+_vm._s(wave.year))]),_vm._v(" "),_c('span',{staticClass:"subtxt"},[_vm._v("n="+_vm._s(_vm.getCount(wave)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }